import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Responsive, Icon } from 'semantic-ui-react';
import { Box, Flex } from 'rebass';
import { Text } from '@tcaster/tcaster-web-lib';
import { COLOR, FONT_SIZE } from '@tcaster/tcaster-theme';

import MyDepartments from '../../Containers/MyDepartments';
import ScoreForm from '../../Containers/ScoreForm';
import { BrowseUniversityModal } from '../../Containers/BrowseUniversity';
import CalculateScoreButton from '../../Containers/CalculateScoreButton';
import AppContainer from '../AppContainer';

const Toolbar = () => (
  <Flex flexDirection={['column', 'row']} justifyContent="space-between" alignItems={'center'}>
    <Box width={'100%'} mb={[2, 0]}>
      <Text fontSize={[FONT_SIZE.large]}>คณะในดวงใจ</Text>
    </Box>

    <Flex width={['100%', 'unset']}>
      <BrowseUniversityModal
        trigger={
          <Button primary circular fluid compact style={{ minWidth: '150px', height: '40px' }}>
            <Icon name="plus" size="small" />
            <Text is="span" fontWeight="400" color={COLOR.white}>
              เพิ่มคณะในดวงใจ
            </Text>
          </Button>
        }
      />
      <Responsive maxWidth={767} as={Fragment}>
        <CalculateScoreButton
          fluid
          compact
          style={{ margin: '0', minWidth: '150px', height: '40px' }}
        />
      </Responsive>
    </Flex>
  </Flex>
);

export default class Dashboard extends Component {
  render() {
    const { menus } = this.props;
    return (
      <AppContainer menus={menus}>
        <Box>
          <Toolbar />
          <Divider />
          <Flex>
            <Box width={[1, 1, 1 / 2]} pr={[0, 0, 3]}>
              <MyDepartments />
            </Box>

            <Responsive as={props => <Box width={1 / 2} {...props} />} minWidth={768}>
              <ScoreForm />
            </Responsive>
          </Flex>
        </Box>
      </AppContainer>
    );
  }
}
